import { ApplicationPropertyType } from 'src/components/ApartmentPageV2/ApartmentGallery/types';
import { IApplicationProperty } from 'src/typings/viewConfig';

export const getApplicationProperty = (props: IApplicationProperty[], systemName: ApplicationPropertyType): IApplicationProperty | undefined => {
  return props.find((prop) => prop.systemName === systemName);
};
